<div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
  <form autocomplete="off" role="form">
    <div class="float-left bg-white">

      <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true' (click)="backToRegistration()"></app-content-top-nav>
<ng-container *ngIf="errorType === 'Success'">
  <div class="col-md-12 clear-all wrapper">
    <h1 class="title-text custom-header-h2">{{contentData.successHeader}}</h1>
  </div>
  <div class="col-md-12 clear-all content-wrapper">
    <p class="font-weight-300 font-size subtitle clear-all" [innerHTML]="contentData.emailData" >
      <!-- {{contentData.emailData}} -->
    </p>
  </div>
  <!-- <div class="col-md-12 clear-all content-wrapper">
    <p class="font-weight-300 font-size subtitle clear-all">
      {{contentData.recordCallsData}}
    </p>
  </div> -->
  <!-- <div class="col-md-12 clear-all content-wrapper">
    <p class="font-weight-300 font-size subtitle clear-all">
      {{contentData.additionalInfo}}
    </p>
  </div> -->
</ng-container>
<ng-container *ngIf= "errorType ==='Failure'|| errorType ==='Unavailable'">
  <div class="col-md-12 clear-all wrapper">
    <h2 class="title-text">{{contentData.failureHeader}}</h2>
  </div>
  <div class="col-md-12 clear-all content-wrapper">
      <p class="font-weight-300 font-size subtitle clear-all margin-top-15">
        {{contentData.additionalInfo}}
      </p>
    <p class="font-weight-300 font-size subtitle clear-all">
      {{contentData.contactUs}}
    </p>
  </div>
</ng-container>
<ng-container *ngIf= "errorType ==='Registered'">
  <div class="col-md-12 clear-all wrapper">
    <h2 class="title-text">{{contentData.successHeader}}</h2>
  </div>
  <div class="col-md-12 clear-all content-wrapper">
    <p class="font-weight-300 font-size subtitle clear-all">
      Thank you for trying to register but you already have an online account with us. Please<a class="login" (click)="logIn()">log in here</a> to access your account.
    </p>
  </div>
</ng-container>
<div class="col-md-12 underline margin-top">
</div>
      </div>
    </form>
    </div>
      
      